import { render } from "./awaiting_beds_index.vue?vue&type=template&id=56c41a8d&scoped=true"
import script from "./awaiting_beds_index.vue?vue&type=script&lang=js"
export * from "./awaiting_beds_index.vue?vue&type=script&lang=js"

import "./awaiting_beds_index.vue?vue&type=style&index=0&id=56c41a8d&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c41a8d"]])

export default __exports__